import { ENV, getEnv } from 'astra-core/utils/env'
import { useCallback, useEffect } from 'react'
import { broadcastProviderActions } from 'astra-core/containers/BroadcastProvider'

import { useInterval } from 'hooks'
import { useAppDispatch } from 'store'
import { useAppFeatureFlag } from 'shared/config'

import { BROADCAST_CHUNK_SIZE, BROADCAST_POLLING_INTERVAL } from '../constants'

export const useFetchBroadcastsAvailability = (
  eventIds: number[],
  enableFetch = true
) => {
  const dispatch = useAppDispatch()
  const isBroadcastFeatureFlagEnabled = useAppFeatureFlag('BROADCAST_ENABLED')

  const env = getEnv()
  const isBroadcastsEnabled =
    isBroadcastFeatureFlagEnabled &&
    [ENV.STAGE, ENV.PROD].includes(env) &&
    enableFetch

  const fetchBroadcastsAvailability = useCallback(() => {
    if (isBroadcastsEnabled && eventIds.length > 0) {
      for (let i = 0; i < eventIds.length; i += BROADCAST_CHUNK_SIZE) {
        dispatch(
          broadcastProviderActions.fetchBroadcastsAvailability({
            reqData: {
              eventIds: eventIds.slice(i, i + BROADCAST_CHUNK_SIZE)
            }
          })
        )
      }
    }
  }, [dispatch, eventIds, isBroadcastsEnabled])

  useEffect(() => {
    fetchBroadcastsAvailability()
  }, [eventIds, fetchBroadcastsAvailability])

  useInterval(fetchBroadcastsAvailability, BROADCAST_POLLING_INTERVAL, true)
}
